<template>
  <Page>
    <template v-slot:page-header>
      <div class="container">
        <div class="page-header">
          <div class="title-container">
            <div class="title">
              <div class="header-container">
                <div class="title-header">สร้างแลนดิ้งเพจใหม่</div>
              </div>
            </div>
          </div>
          <div class="actions">
            <small class="text-danger mr-3"
              v-if="isServerError()">
              {{getErrorMessageFromErrorStatus(errorStatus)}}
            </small>
            <!-- <small class="text-danger mr-3" v-if="haveErrorMessage">
              โปรดระบุรายการ และชื่อตอน
            </small> -->
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="!isValid"
              @click.stop="onSubmit">
              บันทึก
            </button>
          </div>
        </div>
      </div>
    </template>
    <div class="container">
      <div class="section-container">
        <SectionLandingPageInformation
          :landingPage.sync="landingPageData"
          :saveLandingPageStateError.sync="savelandingPageState.error" />
      </div>
    </div>
  </Page>
</template>

<script>
// import _ from 'lodash';
import { createLandingPage } from '@/landingpage/api';
import Page from '@/layouts/Page.vue';
import SectionLandingPageInformation from '@/landingpage/SectionLandingPageInformation.vue';

export default {
  components: {
    Page,
    SectionLandingPageInformation,
  },
  data() {
    return {
      landingPageData: {
        title: null,
        redirectUrl: null,
        startPublish: null,
        endPublish: null,
      },
      savelandingPageState: {
        isSaving: false,
        isSaved: false,
        error: {
          title: null,
          redirectUrl: null,
          startPublish: null,
          endPublish: null,
        },
      },
      errorStatus: null,
      emptyFieldError: null,
    };
  },
  computed: {
    isValid() {
      return true;
    },
  },
  methods: {
    isServerError() {
      return this.errorStatus;
    },
    getErrorMessageFromErrorStatus(errorStatus) {
      if (errorStatus === 500) {
        return `พบข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองอีกครั้งหรือติดต่อผู้ดูแลระบบ code : ${errorStatus}`;
      }
      if (errorStatus === 422) {
        return 'กรอกข้อมูลไม่ถุกต้อง กรุณาตรวจสอบข้อมูลอีกครั้ง';
      }
    },
    async onSubmit() {
      this.savelandingPageState.isSaving = true;
      try {
        await createLandingPage(this.landingPageData);
        this.$router.push('/landingpage');
      } catch (error) {
        this.errorStatus = error.response.status;
        this.savelandingPageState.error = error.response.data;
        this.savelandingPageState.isSaving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/section-container.scss';
</style>
